<div class="content dark">
	<p>Note that regenerating HIs can take some time and will wipe out any history of alternate engine
		config. You should recalculate states (below) afterwards.</p>
	<div class="row my-3">
		<div class="col-sm-5">
			<app-action-button [action]="GenerateHIs" [context]="this" processing="Generating..." complete="HIs regenerated">Regenerate HI values</app-action-button>
		</div>
		<div class="col-sm-7">
			<p *ngIf="hiStatus">
				<ngb-progressbar type="success" [value]="hiProgress"></ngb-progressbar>
			</p>
			{{hiStatus}}
		</div>
	</div>
	<p>Recalculate component states when the underlying data has been changed but components are still
		in warning.</p>
	<div class="row my-3">
		<div class="col-sm-5">
			<app-action-button [action]="RecalculateStates" [context]="this" processing="Recalculating..." complete="States recalculated">Recalculate component states
			</app-action-button>
		</div>
	</div>
</div>